import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button } from "antd";
import _ from "i18n";

import { setCollaboratorHolidayType } from "Actions";
import {
  deleteCollaboratorHolidayType,
  saveCollaboratorHolidayType,
  fetchSettingCollaborators,
  fetchCollaboratorSettingSuggestions
} from "Thunks";

import { onSuccess, onError } from "Utils";
import { DIALOG_TYPES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import { SettingIcon, SvgIcon, ICONS, GarbageIcon } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";

import styles from "./RegimeSettingContent.local.scss";
import CheckBoxBtn from "../Common/Checkbox/CheckBoxBtn";

class HolidayTypesSettingContent extends Component {
  // **** HolidayTypeSettingContent (functions) ***** //
  constructor(props) {
    super(props);
    this.state = {
      collaborator: props.collaborator,
      idHolidayType: null,
      holidayType: {
        id: null,
        label: "",
        isVoluntary: true
      },
      disabledSave: true,
      deleteHolidayTypeIsVisible: false,
      deleteHolidayTypeIsForced: false
    };
  }

  handleDisplayDeleteHolidayType = id => {
    this.setState({
      idHolidayType: id,
      deleteHolidayTypeIsVisible: true
    });
  };

  handelDisplayDeleteForced = id => {
    this.setState({
      idHolidayType: id,
      deleteHolidayTypeIsForced: true
    });
  };

  handleDeleteHolidayType = () => {
    const { settingSuggestions } = this.props;
    let isForse = false;
    let updatedHolidayTypes = settingSuggestions.data.holidayTypes;

    let { idHolidayType } = this.state;
    this.setState({ loading: true });
    if (this.state.deleteHolidayTypeIsForced) {
      isForse = true;
    }
    this.props
      .dispatch(deleteCollaboratorHolidayType(idHolidayType, isForse))
      .then(
        res => {
          this.setState({ loading: false });
          onSuccess(res, {
            title: _("removeSuccess"),
            body: _("holidayTypeDeleted")
          });
          this.props.dispatch(
            setCollaboratorHolidayType(
              updatedHolidayTypes.filter(({ id }) => id !== idHolidayType)
            )
          );
          this.props.dispatch(fetchSettingCollaborators());
          this.cancelDeleteHolidayType();
          this.cancelDeleteForcedHolidayType();
        },
        err => {
          this.cancelDeleteHolidayType();
          this.setState({ loading: false });
          onError(err.response.data.errors[0].message);
          if (!this.state.deleteHolidayTypeIsForced) {
            this.handelDisplayDeleteForced(idHolidayType);
          } else {
            this.cancelDeleteForcedHolidayType();
          }
        }
      );
  };

  cancelDeleteHolidayType = () => {
    this.setState({
      idHolidayType: null,
      deleteHolidayTypeIsVisible: false
    });
  };
  cancelDeleteForcedHolidayType = () => {
    this.setState({
      idHolidayType: null,
      deleteHolidayTypeIsForced: false
    });
  };

  handlePrepareUpdateHolidayType = holidayTypeToUpdate => {
    this.setState({ holidayType: holidayTypeToUpdate });
  };

  handleChangeHolidayTypeLabel = event => {
    this.setState({
      holidayType: { ...this.state.holidayType, label: event.target.value },
      disabledSave: false
    });
  };

  handleChangeHolidayVoluntary = () => {
    this.setState({
      holidayType: {
        ...this.state.holidayType,
        isVoluntary: !this.state.holidayType.isVoluntary
      },
      disabledSave: false
    });
  };

  cancelUpdateHolidayType = () => {
    this.setState({
      holidayType: {
        id: null,
        label: "",
        isVoluntary: true
      },
      disabledSave: true
    });
  };

  handleSaveHolidayType = () => {
    const { holidayType } = this.state;
    const { dispatch } = this.props;
    dispatch(saveCollaboratorHolidayType(holidayType)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: holidayType.id
            ? _("holidayTypeUpdated")
            : _("holidayTypeCreated")
        });
        dispatch(fetchSettingCollaborators());
        dispatch(fetchCollaboratorSettingSuggestions());
        this.setState({
          disabledSave: true,
          holidayType: {
            id: null,
            label: "",
            isVoluntary: true
          }
        });
      },
      err => {
        onError(
          err.response.data.errors
            ? err.response.data.errors[0].message
            : _("error")
        );
      }
    );
  };

  render() {
    const { settingSuggestions } = this.props;
    const { holidayType } = this.state;
    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SettingIcon fill="#2495E1" size="20" />
            </div>
            <div className="upload-modal__header-title">
              {_("titleModalHolidayType")}
            </div>
          </div>
          <div className={styles.modal_content}>
            <div
              className={classnames(
                "columns medium-5 small-5",
                styles.form_frame
              )}
            >
              <h3>{_(holidayType.id ? "updateType" : "createType")}</h3>
              <div
                className={classnames(
                  "columns medium-12 small-12",
                  styles.input_div
                )}
              >
                <span>{_("title")}</span>
                <input
                  type={"text"}
                  value={holidayType.label}
                  onChange={event => this.handleChangeHolidayTypeLabel(event)}
                />
              </div>
              <div className={{ position: "absolute" }}>
                <div className={styles.checkbox} style={{ marginTop: "1px" }}>
                  <div>
                    <CheckBoxBtn
                      id="select-all"
                      checked={holidayType.isVoluntary}
                      onChange={() => this.handleChangeHolidayVoluntary()}
                    />
                  </div>
                  <div className={styles.label}> congé volontaire</div>
                </div>
                <div>
                  <div className={styles.checkbox} style={{ marginTop: "1px" }}>
                    <CheckBoxBtn
                      id="select-allYT"
                      checked={!holidayType.isVoluntary}
                      onChange={() => this.handleChangeHolidayVoluntary()}
                    />
                  </div>
                  <div className={styles.label}>congé involontaire</div>
                </div>
              </div>
              <div>
                <button
                  type={"success"}
                  className={styles.save_button}
                  disabled={this.state.disabledSave}
                  onClick={this.handleSaveHolidayType}
                >
                  <img
                    src={"/img/icons/tail-spin.svg"}
                    alt={""}
                    className={settingSuggestions.saving ? styles.loading : ""}
                  />
                  {_("save")}
                </button>
                {holidayType.id && (
                  <Button
                    type={"success"}
                    style={{
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: 14,
                      height: 37,
                      margin: "18px 3px 0px",
                      background: "transparent",
                      float: "left",
                      textTransform: "uppercase",
                      color: "#6D7F92"
                    }}
                    onClick={() => this.cancelUpdateHolidayType()}
                  >
                    {_("cancel")}
                  </Button>
                )}
              </div>
            </div>
            <div
              className={classnames(
                "columns medium-6 small-6",
                styles.list_frame
              )}
            >
              <h3>
                {_("typesList")} ({settingSuggestions.data.holidayTypes.length})
              </h3>
              <div className={`${styles.list_items} ${styles.list_roles}`}>
                {settingSuggestions.fetching ? (
                  <div className={styles.ripple_loading}>
                    <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                  </div>
                ) : (
                  settingSuggestions.data.holidayTypes &&
                  settingSuggestions.data.holidayTypes.map(holidayType => {
                    return (
                      <div key={holidayType.id} className={styles.item}>
                        <span>{holidayType.label}</span>
                        <div
                          className={styles.actions}
                          onClick={event => {
                            event.stopPropagation();
                          }}
                        >
                          {holidayType.id !== 1 && holidayType.id !== 2 ? (
                            <div>
                              <span
                                className={`${styles.action} ${
                                  styles.action_edit
                                }`}
                                onClick={() =>
                                  this.handlePrepareUpdateHolidayType(
                                    holidayType
                                  )
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.PENCIL}
                                  className={styles.edit}
                                />
                              </span>
                              <span
                                className={`${styles.action} ${
                                  styles.action_delete
                                }`}
                                onClick={() =>
                                  this.handleDisplayDeleteHolidayType(
                                    holidayType.id
                                  )
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.Garbage}
                                  className={styles.delete}
                                />
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <TTPDialog
          showDialog={this.state.deleteHolidayTypeIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteHolidayType,
            abortAction: this.cancelDeleteHolidayType,
            message: _("confirmationDeleteHolidayTypeMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: "yes",
            abortBtnLabel: "no",
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteHolidayTypeTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteHolidayTypeIsForced}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteHolidayType,
            abortAction: this.cancelDeleteForcedHolidayType,
            message: _("confirmationForcedDeleteCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationForceDeleteCategoryTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settingSuggestions: state.collaborator.settingSuggestions
});

export default connect(mapStateToProps)(HolidayTypesSettingContent);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/HolidayTypesSettingContent.js